import React, { useCallback, memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { helpIcon } from 'assets';
import ProfileMenu from '../profile-menu/ProfileMenu';
import styles from './styles.module.css';
import Button from '../button/Button';
import NotificationsBell from './NotificationsBell';
import OrganisationSelect from './OrganisationSelect';

const Header = memo(
  ({
    title,
    buttonText = '',
    onClickButton = null,
    childComponent = null,
    hideOrganisation = false,
  }) => {
    const noButton = typeof onClickButton !== 'function' && !buttonText;

    function Title() {
      // Function to render the title based on its type
      const renderTitle = () => {
        if (typeof title === 'string') {
          return title; // Render the string directly
        }
        if (typeof title === 'function') {
          return title(); // Call the function to get JSX
        }
        return title; // Assume it's JSX and render it directly
      };

      return (
        <div
          className={styles.title}
          title={typeof title === 'string' ? title : undefined}
        >
          {renderTitle()}
        </div>
      );
    }

    const navigateToHelpGuide = () => {
      window.open('https://help-tvs.op2mise.ai/docs/', '_blank');
    };

    return (
      <div className={styles.banner}>
        {/* <div className={styles.title} title={title}>{title}</div> */}
        {Title()}
        <div className={styles.actionWrapper}>
          <div className={styles.floatRight}>
            {!noButton && <Button text={buttonText} onClick={onClickButton} />}
            {!hideOrganisation && <OrganisationSelect />}
            {childComponent}
            <div className={styles.iconGroup}>
              <img
                className={styles.helpIcon}
                src={helpIcon}
                title="Help"
                alt=""
                onClick={navigateToHelpGuide}
              />
              <NotificationsBell />
              <ProfileMenu />
            </div>
          </div>
        </div>
      </div>
    );
  },
);

Header.propTypes = {
  componentName: PropTypes.string,
  buttonText: PropTypes.string,
  onClickButton: PropTypes.func,
  childComponent: PropTypes.node,
  hideOrganisation: PropTypes.bool,
};

export default Header;
